// extracted by mini-css-extract-plugin
export default {"tutorial":"Tutorial_tutorial__gekDA","step":"Tutorial_step__ktaYK","navigation":"Tutorial_navigation__EYg4H","showButton":"Tutorial_showButton__dLlYn"};